import { Utils } from "../../../common/views/Utils";
import { ShortOrderItemModel } from "../../../orders/models/OrderModel";
import { OrderUtils } from "../../../orders/views/shared/OrderUtils";
import { ProductUtils } from "../../../products/ProductUtils";

type InvoicePrintItemProps = {
    item: ShortOrderItemModel;
}

export default function InvoicePrintItemView({ item }: InvoicePrintItemProps) {
    const width3 = Utils.getColumnWidth(3);
    const width9 = Utils.getColumnWidth(9);

    const url = ProductUtils.getImageUrl(item.imageUrl);
    const productLine2 = ProductUtils.getSubInfo(item.lineName, item.size, item.code);
    const total = item.price * item.qty

    return <div className="ms-Grid-row pv-15">
        <div className={width3 + " left"}>
            {OrderUtils.image(url, item.qty, 80, 0, false)}
        </div>
        <div className={width9 + " font-smaller"}>
            <div>{item.brand}</div>
            <div className="pt-5 gray">{item.productName}</div>
            {!Utils.isNullOrEmpty(productLine2) && <div className="pt-5">{productLine2}</div>}

            <div className="pt-5 font-bold">
                ${item.price.toFixed(2)} (x{item.qty}) = ${total.toFixed(2)}
            </div>

            {!Utils.isNullOrEmpty(item.note) && <div className="firmed pt-10" style={{ fontSize: "x-small" }}>
                {item.note}
            </div>}
        </div>
    </div>
}